import React from "react";

const Header = ({ name, role }) => {
  return (
    <div
      id="Report-Detail-Header"
      data-testid="Report-Detail-Header"
      className=""
    >
      <div className="flex">
        <div className="flex-col flex-1">
          <p>{name ? name : ""}</p>
          <p>{role ? role : ""}</p>
        </div>
      </div>
    </div>
  );
};
export default Header;
